import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UrlRequestService } from '../../cross-team-shared/misc-services/resources/url-request.service';

@Injectable({ providedIn: 'root' })
export class SegmentationMaskResource extends UrlRequestService {
  // eslint-disable-next-line max-params-unless-injectable -- required to make the resource request
  getSegmentationMask(
    projectId: number,
    taskId: string,
    outputId: number,
    frameNumber: number,
    token: string,
  ) {
    return this.downloadResourceWithRetries(
      segmentationMaskPath(projectId, taskId, outputId, frameNumber),
      {
        headers: { 'X-Kaguya-Token': `Bearer ${token}` },
      },
    );
  }
}

export function segmentationMaskPath(
  projectId: number,
  taskId: string,
  outputId: number,
  frameNumber: number,
) {
  return `${environment.assetServiceBaseUrl}/api/v1/projects/${projectId}/tasks/${taskId}/outputs/${outputId}/masks/${frameNumber}`;
}
